import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import Dialog from '../../../../components/ModalDialog'
import CreateIcon from '../../../../assets/icons/settingsCorner/iconsCreate'
import { StyledDivContent, StyledInputTitle, sxInput } from '../../styled'
import AutoComplete from '../../../../components/AutoComplete'

function SalesChannelModal({
  open,
  handleClose,
  modalTitle,
  salesChannelList,
  isLoadingSalesChannelList,
  keys,
  fetchKeys,
  searchKeys,
  getSalesChannels,
  getSalesChannelsMore,
  salesChannelListCount,
  assign,
  isLoadingAssign,
  success,
  errorMessage,
  isLoadingKeysList,
  fetchMoreKeys,
  keysCount,
  resetConfig,
}) {
  const [init, setInit] = useState(false)

  const [selectSalesChannel, setSelectSalesChannel] = useState(false)
  const [searchSalesChannel, setSearchSalesChannel] = useState('')
  const [salesChannel, setSalesChannel] = useState('')
  const [offsetSalesChannel, setOffsetSalesChannel] = useState(25)

  const [selectKey, setSelectKey] = useState(false)
  const [searchKey, setSearchKey] = useState('')
  const [key, setKey] = useState('')
  const [offsetKey, setOffsetKey] = useState(25)

  const UserId = String(JSON.parse(localStorage.getItem('currentUser'))?.id)
  const date = new Date().toISOString()

  useEffect(() => {
    getSalesChannels({ offset: 0, limit: 25 })
    fetchKeys()
    setInit(true)
  }, [])

  useEffect(() => {
    const delayDebounceFn = setTimeout(() => {
      if (searchSalesChannel.length > 0 && !selectSalesChannel) {
        getSalesChannels({ offset: 0, limit: 25, query: searchSalesChannel })
        setOffsetSalesChannel(25)
      } else if (searchSalesChannel == '') {
        if (init) {
          getSalesChannels({ offset: 0, limit: 25 })
        }
      }
    }, 500)

    return () => clearTimeout(delayDebounceFn)
  }, [searchSalesChannel])

  const onChangeSearchSalesChannel = (value) => {
    setSelectSalesChannel(false)
    if (value) {
      let val = value.trim()
      setSearchSalesChannel(val)
    } else {
      setSalesChannel('')
      setSearchSalesChannel('')
      setSelectSalesChannel(false)
    }
  }

  const onSelectSalesChannel = (value) => {
    if (value) {
      setSalesChannel(value)
      setSelectSalesChannel(true)
    }
  }

  const loadMoreSalesChannels = (event) => {
    if (
      Math.round(event.target.scrollHeight - event.target.scrollTop) ==
        event.target.clientHeight &&
      salesChannelListCount >= offsetSalesChannel
    ) {
      setOffsetSalesChannel(offsetSalesChannel + 25)
      getSalesChannelsMore({
        offset: offsetSalesChannel,
        limit: 25,
        query: searchKey,
      })
    }
  }

  useEffect(() => {
    const delayDebounceFn = setTimeout(() => {
      if (searchKey.length > 0 && !selectKey) {
        searchKeys(searchKey)
        setOffsetKey(25)
      } else if (searchKey == '') {
        if (init) {
          searchKeys('')
        }
      }
    }, 500)

    return () => clearTimeout(delayDebounceFn)
  }, [searchKey])

  const onChangeSearchKey = (value) => {
    setSelectKey(false)
    if (value) {
      let val = value.trim().toUpperCase()
      setSearchKey(val)
    } else {
      setKey('')
      setSearchKey('')
      setSelectKey(false)
    }
  }

  const onSelectKey = (value) => {
    if (value) {
      setKey(value)
      setSelectKey(true)
    }
  }

  const loadMoreKeys = (event) => {
    if (
      Math.round(event.target.scrollHeight - event.target.scrollTop) ==
        event.target.clientHeight &&
      keysCount >= offsetKey
    ) {
      setOffsetKey(offsetKey + 25)
      fetchMoreKeys(offsetKey)
    }
  }

  const onChangeAssign = () => {
    const data = {
      affectDate: date,
      keyId: key.id,
      userId: String(UserId),
      salesChanelCode: salesChannel.code,
    }
    assign(data)
  }

  useEffect(() => {
    if (success) {
      handleClose()
    }
  }, [success])

  useEffect(() => {
    window.addEventListener('beforeunload', resetConfig)

    return () => {
      resetConfig()
      window.removeEventListener('beforeunload', resetConfig)
    }
  }, [])

  return (
    <Dialog
      maxWidthDialog={'md'}
      open={open}
      title={modalTitle}
      iconTitle={<CreateIcon />}
      style={errorMessage ? { display: 'none' } : {}}
      content={
        <StyledDivContent>
          <StyledInputTitle>Canal</StyledInputTitle>

          <AutoComplete
            value={salesChannel}
            onChange={(event, value) => {
              onSelectSalesChannel(value)
            }}
            onInputChange={(event, value) => onChangeSearchSalesChannel(value)}
            id="Canal-list"
            options={salesChannelList}
            getOptionLabel={(option) => `${option.name}`}
            variant="outlined"
            placeholder={'Choisir un canal'}
            sxInputStyle={sxInput}
            ListboxProps={{
              onScroll: loadMoreSalesChannels,
            }}
            renderOption={(props, option, index) => (
              <li key={index.index} id={`canal-${option.id}`} {...props}>
                <div className="AutoCompteFilterOption"> {`${option.name} `}</div>
              </li>
            )}
            loading={isLoadingSalesChannelList}
          />
          <div style={{ marginTop: '20px', width: '100%' }}>
            <StyledInputTitle>Clé </StyledInputTitle>{' '}
            <AutoComplete
              value={key}
              onChange={(event, value) => {
                onSelectKey(value)
              }}
              onInputChange={(event, value) => onChangeSearchKey(value)}
              id="Cle-Canal-list"
              options={keys}
              getOptionLabel={(option) => option.value}
              variant="outlined"
              placeholder={'Choisir une clé'}
              sxInputStyle={sxInput}
              ListboxProps={{
                onScroll: loadMoreKeys,
              }}
              renderOption={(props, option) => (
                <li {...props} id={`cle-${option.id}`} key={option.id}>
                  <div className="AutoCompteFilterOption">{option.value}</div>
                </li>
              )}
              loading={isLoadingKeysList}
            />
          </div>
        </StyledDivContent>
      }
      handleClose={handleClose}
      handleClickAction={onChangeAssign}
      disabled={!salesChannel || !key}
      isLoadingButtonAction={isLoadingAssign}
    />
  )
}
SalesChannelModal.propTypes = {
  open: PropTypes.bool,
  handleClose: PropTypes.func,
  keys: PropTypes.array,
  modalTitle: PropTypes.string,
  salesChannelList: PropTypes.array,
  fetchKeys: PropTypes.func,
  salesChannelListCount: PropTypes.number,
  isLoadingSalesChannelList: PropTypes.bool,
  searchKeys: PropTypes.func,
  assign: PropTypes.func,
  isLoadingAssign: PropTypes.bool,
  errorMessage: PropTypes.bool,
  success: PropTypes.bool,
  getSalesChannels: PropTypes.func,
  isLoadingKeysList: PropTypes.bool,
  fetchMoreKeys: PropTypes.func,
  keysCount: PropTypes.number,
  resetConfig: PropTypes.func,
  getSalesChannelsMore: PropTypes.func,
}

export default SalesChannelModal
